import type { User } from '@/types/domain/user';
import type { AuthLoginResponseDto, SignInUserDto } from '@/types/dto/auth.dto';
import { createContext } from 'react';

export interface AuthContextValue {
  clearAuth: () => void;
  isAuthenticated: boolean;
  isLoading: boolean;
  logout: () => Promise<void>;
  signIn: (data: SignInUserDto) => Promise<AuthLoginResponseDto>;
  setVerificationToken: (token: string | null) => void;
  user: User | null;
  verificationToken: string | null;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
